import { useSelector } from 'react-redux';
import { DemographicAppKeys } from '../../../global/models/demographics-model';
import { SuccessMessageWithNBA } from '../../../global/models/epi-model';
import { TcsmStates } from '../../../root/tcsm-model';
import { AnnualEnrollmentState } from '../models/annual-enrollment-models';

export function useAnnualEnrollmentFatalError(app: DemographicAppKeys) {
	const annualEnrollmentState = useSelector<TcsmStates, AnnualEnrollmentState>(state => state.annualEnrollment[app]);
	const messageMapping = useSelector<TcsmStates, { [key: string]: SuccessMessageWithNBA }>(a => a.epiProps?.siteSettingsState?.siteSettings?.apiResponseMessages);

	const apiResponse = annualEnrollmentState?.AEInfo?.api_response;
	if (!apiResponse?.status || apiResponse.status === 'OK') return null;


	return messageMapping[apiResponse.status.toLowerCase()] ? messageMapping[apiResponse.status.toLowerCase()].title : apiResponse.message;
}